"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactResponsive = require("react-responsive");
var _reactstrap = require("reactstrap");
var _utils = require("../../../utils");
var _fonts = require("../fonts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Title = function Title(_ref) {
  var children = _ref.children,
    tag = _ref.tag,
    className = _ref.className;
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.sm
  });
  var Title = isMobile ? _fonts.H5 : tag !== null && tag !== void 0 ? tag : _fonts.H4;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.CardTitle, {
    className: "mb-0 ".concat(className),
    tag: Title
  }, children);
};
exports.Title = Title;